module.exports = __webpack_public_path__ + "img/lupe.bbc925a5.svg";